export enum DataTrackerEvents {
    clickNotificationButtonManage = 'DASHBOARD.CLICK_ON_GAUGES_NOTIFICATION_MANAGE_BUTTON',
    clickNotificationButtonContact = 'DASHBOARD.CLICK_ON_GAUGES_NOTIFICATION_CONTACT_BUTTON',
    clickNotificationButtonUpgrade = 'DASHBOARD.CLICK_ON_GAUGES_NOTIFICATION_UPGRADE_BUTTON',
    clickNewRequestButton = 'DASHBOARD.CLICK_ON_NEW_REQUEST_BUTTON',
    clickTrialBarButton = 'DASHBOARD.CLICK_ON_TRIAL_BAR_BUTTON',
    clickDemoBarButton = 'DASHBOARD.CLICK_ON_DEMO_BAR_BUTTON',
    HasCompletedTour = 'DASHBOARD.HAS_COMPLETED_TOUR',
    SendVerifyEmailModalViewed = 'DASHBOARD.SEND_VERIFY_EMAIL_MODAL_VIEWED',
    typeOfRequestHasBeenSelected = 'TEMPLATES.TYPE_OF_REQUEST_HAS_BEEN_SELECTED',
    newQualifiedRequestButtonClicked = 'NEW_QUALIFIED_REQUEST_BUTTON_CLICKED',
}
